(function () {
  "use strict";

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

  const productHandles = {
    ["PSB1-S"]: "prism-rhythm",
    PSB2: "ripple-soundbar",
    PSB3: "prism-symphony-soundbar",
    ps421: "ps421",
    "ps801-pro": "swivel-mounting-above-43",
    "ps901-pro": "swivel-mounting-above-75-ps901-pro",
    "ps1201-pro": "ps1201-pro",
    pf421: "fixed-mounting-32",
    pf701: "fixed-mounting-above-43",
    pt1001: "fixed-mounting-above-75-pt1001",
    MTSPRO: "mtspro",
    KANVAQUAD: "kanva-quad-tv-stand",
    KANVATRIPOD: "kanva-tripod-tv-stand",
    "Arc 01": "arc-01",
    "Arc Beam": "arc-beam",
    "Arc Lite": "arc-lite",
    "Arc Lite Dual": "arc-lite-dual",
    "Arc Stealth": "arc-stealth-single",
    "Arc Stealth Dual": "arc-stealth-dual",
    "Arc Stealth Pro": "arc-stealth-pro",
    "Arc Stealth Pro Add on Kit": "arc-stealth-pro-add-on-kit",
    "Arc Titan": "arc-titan",
    "Arc Titan Dual": "arc-titan-dual",
    "Arc Titan Pro": "arc-titan-pro",
    "Arc Titan Pro Add on Kit": "arc-titan-pro-add-on-kit",
    "Laptop Holder": "laptop-holder",
    "Vantage Ascend Dual": "vantage-ascend-dual",
    "Vantage Dual": "vantage-dual",
  };

  class CartCrossSell extends HTMLElement {
    constructor() {
      super();
    }

    async connectedCallback() {
      await this.renderProducts();
      this.handleCartRemove();
    }

    async getCrossSellProducts() {
      const cartData = await (await fetch("/cart.json")).json();
      const cartItems = cartData.items;
      const cartItemsHandle = [...new Set(cartItems.map((x) => x.handle))];

      let crossSellHandles = [];
      cartItemsHandle.forEach((handle) => {
        switch (handle) {
          case "prism-q43-ultra":
          case "q55u-q55-ultra-qled-google-tv":
          case "q65u-q65-ultra-qled-google-tv":
          case "q43u-2026":
          case "q55u-2026":
          case "q65u-2026":
            crossSellHandles.push(productHandles.pf701);
            crossSellHandles.push(productHandles["ps801-pro"]);
            crossSellHandles.push(productHandles["PSB1-S"]);
            break;

          case "q75u-q75-ultra-qled-google-tv":
          case "q75u-2026":
            crossSellHandles.push(productHandles.pt1001);
            crossSellHandles.push(productHandles["ps901-pro"]);
            crossSellHandles.push(productHandles["PSB1-S"]);
            break;

          case "prism-q100-ultra-qled-google-tv":
            crossSellHandles.push(productHandles.pt1001);
            crossSellHandles.push(productHandles["ps1201-pro"]);
            crossSellHandles.push(productHandles.PSB3);
            break;

          case "q43qe-a-q43qe-google-tv":
          case "q55qe-a-q55qe-google-tv":
          case "q65qe-a-q65qe-google-tv":
          case "q43qe-2026":
          case "q55qe-2026":
          case "q65qe-2026":
            crossSellHandles.push(productHandles.pf701);
            crossSellHandles.push(productHandles["ps801-pro"]);
            crossSellHandles.push(productHandles["PSB1-S"]);
            break;

          case "prism-q75-qe-4k-ai-google-tv":
          case "q75qe-2026":
            crossSellHandles.push(productHandles.pt1001);
            crossSellHandles.push(productHandles["ps901-pro"]);
            crossSellHandles.push(productHandles.MTSPRO);
            break;

          case "prism-u55-qd-mini-led":
          case "u65-qled-mini-led-google":
          case "u55-2026":
          case "u65-2026":
            crossSellHandles.push(productHandles["ps801-pro"]);
            crossSellHandles.push(productHandles.pf701);
            crossSellHandles.push(productHandles.PSB2);
            break;

          case "u75-qled-mini-led-google":
          case "u75-2026":
            crossSellHandles.push(productHandles["ps901-pro"]);
            crossSellHandles.push(productHandles.pt1001);
            crossSellHandles.push(productHandles.PSB3);
            break;

          case "prism-u86-qd-mini-led":
            crossSellHandles.push(productHandles["ps901-pro"]);
            crossSellHandles.push(productHandles.pt1001);
            break;

          case "prism-55al-google-tv":
          case "prism-65al-google-tv":
            crossSellHandles.push(productHandles["ps801-pro"]);
            crossSellHandles.push(productHandles.pf701);
            crossSellHandles.push(productHandles.KANVAQUAD);
            break;

          case "prism-77al-google-tv":
            crossSellHandles.push(productHandles["ps901-pro"]);
            crossSellHandles.push(productHandles.pt1001);
            break;

          case "q32c-q32-google-tv":
            crossSellHandles.push(productHandles.pf421);
            crossSellHandles.push(productHandles.ps421);
            break;

          case "prism-s40-google-tv":
          case "prism-s43-google-tv":
            crossSellHandles.push(productHandles.pf421);
            crossSellHandles.push(productHandles.ps421);
            crossSellHandles.push(productHandles.KANVATRIPOD);
            break;

          case "prism-x240":
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Arc Lite"]);
            crossSellHandles.push(productHandles["Arc Stealth Dual"]);
            break;
          case "prism-x300":
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Arc Stealth Dual"]);
            crossSellHandles.push(productHandles["Arc Beam"]);
            break;
          case "prism-x270-240hz":
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Arc Stealth Dual"]);
            crossSellHandles.push(productHandles["Arc Lite"]);
            break;
          case "prism-x270-pro":
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Arc Lite"]);
            crossSellHandles.push(productHandles["Arc Stealth Dual"]);
            break;
          case "prism-x315-pro":
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Arc Stealth Dual"]);
            crossSellHandles.push(productHandles["Arc Stealth Pro"]);
            break;
          case "prism-x340-pro-180hz":
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Arc Stealth Dual"]);
            crossSellHandles.push(productHandles["Arc Beam"]);
            break;
          case "x340-pro-evo":
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Arc Beam"]);
            crossSellHandles.push(productHandles["Arc Lite"]);
            break;
          case "prism-pg34f-pro":
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Vantage Ascend Dual"]);
            crossSellHandles.push(productHandles["Arc Stealth Pro"]);
            break;
          case "prism-x490":
            crossSellHandles.push(productHandles["Arc Titan"]);
            crossSellHandles.push(productHandles["Laptop Holder"]);
            crossSellHandles.push(productHandles["Arc 01"]);
            break;
          case "prism-x490-pro":
            crossSellHandles.push(productHandles["Arc Titan"]);
            crossSellHandles.push(productHandles["Arc Lite"]);
            crossSellHandles.push(productHandles["Vantage Ascend Dual"]);
            break;
          case "prism-49al":
            crossSellHandles.push(productHandles["Arc Titan"]);
            crossSellHandles.push(productHandles["Arc Titan Pro"]);
            crossSellHandles.push(productHandles["Arc Titan Pro Add on Kit"]);
            break;
          case "prism-49al-240hz":
            crossSellHandles.push(productHandles["Arc Titan"]);
            crossSellHandles.push(productHandles["Vantage Dual"]);
            crossSellHandles.push(productHandles["Vantage Ascend Dual"]);
            break;
          case "prism-x450-pro":
            crossSellHandles.push(productHandles["Arc Titan"]);
            crossSellHandles.push(productHandles["Arc Titan Pro"]);
            crossSellHandles.push(productHandles["Arc Stealth Pro Add on Kit"]);
            break;
          case "prism-32g1x-ultra":
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Arc Stealth Pro Add on Kit"]);
            crossSellHandles.push(productHandles["Vantage Dual"]);
            break;
          case "prism-34g1x-pro":
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Arc Stealth Pro"]);
            crossSellHandles.push(productHandles["Arc Stealth Pro Add on Kit"]);
            break;
          case "prism-f250i":
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Arc Lite"]);
            crossSellHandles.push(productHandles["Arc Stealth Dual"]);
            break;
          case "prism-f245i-300hz":
            crossSellHandles.push(productHandles["Arc Lite"]);
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Arc Beam"]);
            break;
          case "prism-f270i":
            crossSellHandles.push(productHandles["Arc Stealth Dual"]);
            crossSellHandles.push(productHandles["Arc Lite"]);
            crossSellHandles.push(productHandles["Arc Beam"]);
            break;
          case "prism-f270i-pro":
            crossSellHandles.push(productHandles["Arc Lite"]);
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Arc Stealth Dual"]);
            break;
          case "prism-f270i-ultra":
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Arc Stealth Dual"]);
            crossSellHandles.push(productHandles["Arc Lite Dual"]);
            break;
          case "prism-pg27x-pro":
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Arc Stealth Pro Add on Kit"]);
            crossSellHandles.push(productHandles["Arc Stealth Dual"]);
            break;
          case "prism-pg27f-ultra":
            crossSellHandles.push(productHandles["Arc Lite"]);
            crossSellHandles.push(productHandles["Arc Beam"]);
            crossSellHandles.push(productHandles["Arc Stealth"]);
            break;
          case "prism-27g1x-pro":
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Arc Stealth Pro Add on Kit"]);
            crossSellHandles.push(productHandles["Vantage Dual"]);
            break;
          case "prism-27g1x-ultra":
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Arc Stealth Pro Add on Kit"]);
            crossSellHandles.push(productHandles["Vantage Dual"]);
            break;
          case "prism-pg400u-pro":
            crossSellHandles.push(productHandles["Arc Titan"]);
            crossSellHandles.push(productHandles["Arc Titan Dual"]);
            crossSellHandles.push(productHandles["Arc Stealth"]);
            break;
          case "prism-p438":
            crossSellHandles.push(productHandles["Arc Titan"]);
            crossSellHandles.push(productHandles["Arc Titan Dual"]);
            crossSellHandles.push(productHandles["Arc Titan Pro"]);
            break;
          case "prism-pg25x-pro":
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Arc Stealth Pro Add on Kit"]);
            crossSellHandles.push(productHandles["Vantage Dual"]);
            break;
          case "prism-34g1x-pro":
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Arc Stealth Pro"]);
            crossSellHandles.push(productHandles["Arc Titan Pro Add on Kit"]);
            break;
          case "prism-x300":
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Arc Beam"]);
            crossSellHandles.push(productHandles["Arc 01"]);
            break;
          case "prism-x340-pro-180hz":
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Arc Stealth Pro"]);
            crossSellHandles.push(productHandles["Arc Beam"]);
            break;
          case "x340-pro-evo":
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Arc Beam"]);
            crossSellHandles.push(productHandles["Arc Lite"]);
            break;
          case "prism-pg34f-pro":
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Vantage Ascend Dual"]);
            crossSellHandles.push(productHandles["Arc Stealth Pro"]);
            break;
          case "prism-x490":
            crossSellHandles.push(productHandles["Arc Titan"]);
            crossSellHandles.push(productHandles["Laptop Holder"]);
            crossSellHandles.push(productHandles["Arc 01"]);
            break;
          case "prism-x490-pro":
            crossSellHandles.push(productHandles["Arc Titan"]);
            crossSellHandles.push(productHandles["Arc Lite"]);
            crossSellHandles.push(productHandles["Vantage Ascend Dual"]);
            break;
          case "prism-49al":
            crossSellHandles.push(productHandles["Arc Titan"]);
            crossSellHandles.push(productHandles["Arc Titan Pro"]);
            crossSellHandles.push(productHandles["Arc Titan Pro Add on Kit"]);
            break;
          case "prism-49al-240hz":
            crossSellHandles.push(productHandles["Arc Titan"]);
            crossSellHandles.push(productHandles["Vantage Dual"]);
            crossSellHandles.push(productHandles["Vantage Ascend Dual"]);
            break;
          case "prism-x450-pro":
            crossSellHandles.push(productHandles["Arc Titan"]);
            crossSellHandles.push(productHandles["Arc Titan Pro"]);
            crossSellHandles.push(productHandles["Arc Stealth Pro Add on Kit"]);
            break;
          case "prism-c240":
            crossSellHandles.push(productHandles["Arc Lite"]);
            crossSellHandles.push(productHandles["Arc Lite Dual"]);
            crossSellHandles.push(productHandles["Arc Beam"]);
            break;
          case "prism-c270":
            crossSellHandles.push(productHandles["Arc Lite"]);
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Arc Stealth Dual"]);
            break;
          case "prism-c315-max":
            crossSellHandles.push(productHandles["Arc Stealth Pro"]);
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Arc Lite"]);
            break;
          case "prism-c340c-pro":
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Arc Titan Pro"]);
            crossSellHandles.push(productHandles["Arc Titan Pro Add on Kit"]);
            break;
          case "prism-w220v":
            crossSellHandles.push(productHandles["Arc Lite"]);
            crossSellHandles.push(productHandles["Arc Stealth Dual"]);
            crossSellHandles.push(productHandles["Vantage Ascend Dual"]);
            break;
          case "prism-w250":
            crossSellHandles.push(productHandles["Arc Lite"]);
            crossSellHandles.push(productHandles["Arc Lite Dual"]);
            crossSellHandles.push(productHandles["Arc Stealth Dual"]);
            break;
          case "prism-w270-1":
            crossSellHandles.push(productHandles["Arc Lite"]);
            crossSellHandles.push(productHandles["Arc Stealth Dual"]);
            crossSellHandles.push(productHandles["Arc Stealth"]);
            break;
          case "prism-w270pro":
            crossSellHandles.push(productHandles["Arc Lite"]);
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Arc Stealth Dual"]);
            break;
          case "prism-w270-ultra":
            crossSellHandles.push(productHandles["Vantage Dual"]);
            crossSellHandles.push(productHandles["Arc Lite"]);
            crossSellHandles.push(productHandles["Arc Stealth Dual"]);
            break;
          case "prism-w270c-ultra":
            crossSellHandles.push(productHandles["Vantage Dual"]);
            crossSellHandles.push(productHandles["Arc Stealth Dual"]);
            crossSellHandles.push(productHandles["Vantage Ascend Dual"]);
            break;
          case "prism-w270c-pro":
            crossSellHandles.push(productHandles["Arc Stealth"]);
            crossSellHandles.push(productHandles["Arc Lite"]);
            crossSellHandles.push(productHandles["Vantage Dual"]);
            break;

          case "prism-u55-ultra-qd-mini-led-4k-ai-google-tv":
            crossSellHandles.push(productHandles["ps801-pro"]);
            crossSellHandles.push(productHandles.pf701);
            crossSellHandles.push(productHandles.PSB2);
            break;

          case "prism-u65-ultra-qd-mini-led-4k-ai-google-tv":
            crossSellHandles.push(productHandles["ps801-pro"]);
            crossSellHandles.push(productHandles.pf701);
            crossSellHandles.push(productHandles.KANVAQUAD);
            break;

          case "prism-u75-ultra-qd-mini-led-4k-ai-google-tv":
            crossSellHandles.push(productHandles["ps901-pro"]);
            crossSellHandles.push(productHandles.pt1001);
            crossSellHandles.push(productHandles.PSB3);
            break;

          case "prism-u86-ultra-qd-mini-led-4k-ai-google-tv":
            crossSellHandles.push(productHandles["ps901-pro"]);
            crossSellHandles.push(productHandles.pt1001);
            break;

          default:
            break;
        }
      });

      return [...new Set(crossSellHandles)];
    }

    getRandomUniqueNumbers(n) {
      const arr = Array.from({ length: n + 1 }, (_, i) => i);
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
      }
      return arr.slice(0, 4);
    }

    async renderProducts() {
      let crossSellProducts = await this.getCrossSellProducts();
      const cartData = await this.getCartData();
      const cartHandles = cartData.items.map((x) => x.handle);
      crossSellProducts = crossSellProducts.filter(
        (x) => !cartHandles.includes(x)
      );

      if (crossSellProducts.length > 4 && crossSellProducts.length <= 6) {
        crossSellProducts = crossSellProducts.filter((_, i) =>
          [0, 1, 3, 4].includes(i)
        );
      } else if (crossSellProducts.length > 6) {
        const numbers = this.getRandomUniqueNumbers(crossSellProducts.length);
        crossSellProducts = numbers.map((i) => crossSellProducts[i]);
      }

      if (!crossSellProducts.length) {
        this.classList.add("hide");
        $(this).parent().find(".cross-sell-title").addClass("hide");
        return;
      }

      this.classList.add("hide");
      $(this).empty();

      for (const handle of crossSellProducts) {
        const htmlString = await (
          await fetch(`/products/${handle}?section_id=cross-sell-product-card`)
        ).text();
        const parser = new DOMParser();
        const section = parser.parseFromString(htmlString, "text/html");

        // section.querySelectorAll(".variant-color").forEach((x) => {
        //   x.addEventListener("click", function () {
        //     $(this)
        //       .closest(".grid-view-item")
        //       .find(".grid-view-item__image")
        //       .attr("src", $(this).attr("data-image"));
        //     $(this)
        //       .closest(".grid-view-item")
        //       .find(".grid-view-item__link, .grid_shop a")
        //       .attr("href", $(this).attr("data-url"));
        //     $(this)
        //       .closest(".grid-view-item")
        //       .find(".variant-color")
        //       .removeClass("selected");
        //     $(this).addClass("selected");
        //   });
        // });

        section
          .querySelector(".v_hoverWrap a.grid-view-item__link")
          .addEventListener("click", async function (e) {
            e.preventDefault();
            const variantId = $(this)
              .closest(".v_hoverWrap")
              .attr("data-first-variant-id");

            try {
              document.body.classList.add("loading");
              await fetch("/cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  items: [
                    {
                      id: variantId,
                      quantity: 1,
                      properties: {
                        _upsell: "cart",
                      },
                    },
                  ],
                }),
              });
              // Update table
              try {
                const htmlString = await (await fetch(`/cart`)).text();
                const parser = new DOMParser();
                const section = parser.parseFromString(htmlString, "text/html");

                let reloadSection = ".cart-table";
                $(reloadSection).empty();

                $(section)
                  .find(`${reloadSection} > *`)
                  .each(function (_, x) {
                    $(reloadSection).append(x);
                  });

                const cartCrossSell = $("cart-crosssell")[0];
                await cartCrossSell.renderProducts();
                document.dispatchEvent(new CustomEvent("cart:updated"));
              } catch (error) {
                throw new Error("Failed to remove item(s) from cart.");
              }
              // location.reload();
            } catch (error) {
              console.error(error);
            } finally {
              document.body.classList.remove("loading");
            }
          });
        $(section).find(".grid_shop a").text("Add to cart");

        this.append(section.querySelector(".v_hoverWrap"));
      }

      this.classList.remove("hide");
      $(this).parent().find(".cross-sell-title").removeClass("hide");
    }

    async getCartData() {
      return await (await fetch("/cart.js")).json();
    }

    handleCartRemove() {
      $(document).on("click", ".cart__remove", () => {
        setTimeout(async () => {
          await this.renderProducts();
        }, 2000);
      });
    }
  }

  customElements.define("cart-crosssell", CartCrossSell);

  function run() {
    addStyle();
    addCrossSell();
  }

  function addStyle() {
    let style = document.createElement("style");
    style = document.createElement("style");
    style.textContent = `
      .cross-sell-title {
        margin: 0;
        margin-bottom: 1rem;
        font-size: 20px;
        font-weight: 600;
      }
      cart-crosssell {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 1rem;
      }
      cart-crosssell .v_hoverWrap {
        border: 1px solid #e8e9eb;
        padding: 12px;
        text-align: center;
        transition: ease .3s;
      }
      cart-crosssell .v_hoverWrap:hover {
        box-shadow: 2px 7px 14px #d3cdcd;
      }
      cart-crosssell .v_hoverWrap .grid-view-item {
        height: 100%;
        display: flex;
        flex-direction: column;
        margin: 0;
      }
      cart-crosssell .v_hoverWrap .grid-view-item .grid-view-item__title {
        font-size: 18px;
        margin: 10px 0;
      }
      cart-crosssell .v_hoverWrap .grid-view-item .pro_grid_desc {
        font-size: 13px;
      }
      cart-crosssell .v_hoverWrap .grid-view-item .jdgm-widget.jdgm-widget {
        display: none;
      }
      cart-crosssell .v_hoverWrap .grid-view-item .grid-view-item__meta {
        margin-top: auto;
        padding-top: 10px;
      }
      cart-crosssell .v_hoverWrap .grid-view-item .grid-view-item__meta span.product-price__price {
        color: #000;
      }
      cart-crosssell .v_hoverWrap .grid-view-item .grid-view-item__meta.with-voucher span.product-price__price {
        color: #9b0202;
      }
      cart-crosssell .v_hoverWrap .grid-view-item .grid_shop a {
        background: #900;
        color: #fff;
        padding: 10px 0;
        text-transform: capitalize;
        font-weight: 400;
      }
      @media (min-width: 1024px) {
        [data-section-id="cart-template"] {
          max-width: 1440px;
        }
        cart-crosssell {
          grid-template-columns: repeat(4, 1fr);
        }
      }
    `;
    document.head.append(style);
  }

  function addCrossSell() {
    const crossSell = document.createElement("cart-crosssell");
    crossSell.classList.add("hide");

    const title = document.createElement("p");
    title.innerHTML = "You Might Also Like";
    title.classList.add("cross-sell-title", "hide");

    const cartMain = document.querySelector(".cart-main");
    if (!cartMain) return;

    cartMain.append(title, crossSell);
  }
})();
